module.exports = __webpack_public_path__ + "static/media/photo111.0a449274.jpg";